export type AvatarEntityType = "profile" | "room" | "event" | "organization" | "bubble";

export const AVATAR_CACHE_BUSTER_PREFIX: Record<AvatarEntityType, string> = {
  bubble: "crowdcoursing.bubbleAvatarCacheBuster.",
  event: "crowdcoursing.eventAvatarCacheBuster.",
  organization: "crowdcoursing.organizationAvatarCacheBuster.",
  profile: "crowdcoursing.profileAvatarCacheBuster.",
  room: "crowdcoursing.roomAvatarCacheBuster.",
};
